import { PhoneNumberUtil, PhoneNumberFormat } from 'google-libphonenumber';

export function getValidNationalNumber(number: string, region: string): string {
  try {
    // Special handling for Australian mobile numbers
    if (region === 'AU') {
      // Remove any non-digit characters
      const cleanNumber = number.replace(/\D/g, '');

      // Check if it's a valid Australian mobile number format
      // Australian mobile numbers can be:
      // - 04xxxxxxxx (10 digits, starts with 04)
      // - 4xxxxxxxx (9 digits, starts with 4)
      if (
        (cleanNumber.startsWith('04') && cleanNumber.length === 10) ||
        (cleanNumber.startsWith('4') && cleanNumber.length === 9)
      ) {
        return String(cleanNumber);
      }
    }

    const phoneNumberUtil = PhoneNumberUtil.getInstance();
    const phoneNumber = phoneNumberUtil.parseAndKeepRawInput(number, region);

    const isValidateRegionalNumber = phoneNumberUtil.isValidNumberForRegion(phoneNumber, region);
    if (!isValidateRegionalNumber) {
      throw Error('Number is not a validate number');
    }

    const nationalNumber = phoneNumber.getNationalNumberOrDefault();
    if (!nationalNumber) {
      throw Error('Parse number error');
    }

    return String(nationalNumber);
  } catch (e) {
    throw e;
  }
}

export function getE164FormatNumber(number: string, region: string): string {
  const phoneNumberUtil = PhoneNumberUtil.getInstance();
  const phoneNumber = phoneNumberUtil.parseAndKeepRawInput(number, region);
  const formattedNumber = phoneNumberUtil.format(phoneNumber, PhoneNumberFormat.E164);
  if (!formattedNumber) {
    throw Error('Format number error');
  }
  return formattedNumber;
}

export function getNationalFormatNumber(number: string, region: string): string {
  const phoneNumberUtil = PhoneNumberUtil.getInstance();
  const phoneNumber = phoneNumberUtil.parseAndKeepRawInput(number, region);
  const formattedNumber = phoneNumberUtil.format(phoneNumber, PhoneNumberFormat.NATIONAL);
  if (!formattedNumber) {
    throw Error('Format number error');
  }
  return formattedNumber;
}

export function getInternationalFormatNumber(number: string, region: string): string {
  const phoneNumberUtil = PhoneNumberUtil.getInstance();
  const phoneNumber = phoneNumberUtil.parseAndKeepRawInput(number, region);
  const formattedNumber = phoneNumberUtil.format(phoneNumber, PhoneNumberFormat.INTERNATIONAL);
  if (!formattedNumber) {
    throw Error('Format number error');
  }
  return formattedNumber;
}

export function getDisplayCountryCode(region: string): string {
  const phoneNumberUtil = PhoneNumberUtil.getInstance();
  const countryCode = phoneNumberUtil.getCountryCodeForRegion(region);
  return `+${countryCode}(${region})`;
}

export function getNationalNumber(number: string, region: string): string {
  try {
    const phoneNumberUtil = PhoneNumberUtil.getInstance();
    const phoneNumber = phoneNumberUtil.parseAndKeepRawInput(number, region);

    const nationalNumber = phoneNumber.getNationalNumberOrDefault();
    if (!nationalNumber) {
      throw Error('Parse number error');
    }

    return String(nationalNumber);
  } catch (e) {
    throw e;
  }
}
